import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService, SessionService } from '../../../core/services';

@Component({
  selector: 'app-wallet-return',
  standalone: false,
  templateUrl: './wallet-return.html',
  styleUrl: './wallet-return.scss',
})
export class WalletReturn implements OnInit {
  constructor(
    private route: ActivatedRoute,
    private sessionService: SessionService,
    private notificationService: NotificationService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    const status = this.route.snapshot.data['status'] as 'success' | 'cancelled';

    if (status === 'cancelled') {
      this.notificationService.info('Checkout cancelled no funds were added.');
      this.router.navigate(['/billing']);
      return;
    }

    this.sessionService.loadMe().subscribe({
      next: () => {
        this.notificationService.success('Payment received. Your balance will update shortly if it hasn\'t already.');
        this.router.navigate(['/billing']);
      },
      error: () => this.router.navigate(['/billing']),
    });
  }
}
